import './index.scss'
import * as $ from 'jquery'
import { GrGroup } from 'react-icons/gr'
import { useEffect, useState } from 'react'
import { Loader } from 'components/loader'
import ButtonV3 from 'components/Buttonv3'
import { FeedbackError } from 'components/feedback/error'
import TacticalPanelService from 'services/v3/tacticalPanel.service'

type ListParticipatingClientsModalProps = {
    isVisible: boolean
    onClose: () => void
    productId?: number
    user?: any
    hash: string
}

interface IListParticipatingClientsResponse {
    id_dim_client: number
    client_code: string
    client_name: string
    client_state: string
    client_city: string
}

export const ListParticipatingClientsModal = ({
    isVisible,
    onClose,
    productId,
    user,
    hash,
}: ListParticipatingClientsModalProps) => {
    const [loadingTable, setLoadingTable] = useState(false)
    const [listClients, setListClients] = useState<
        IListParticipatingClientsResponse[] | null
    >(null)

    const modal = {
        icon: <GrGroup color="white" />,
        styles: { maxWidth: '80vw' },
        id: 'participatingClients',
        title: `Clientes`,
    }
    useEffect(() => {
        if (isVisible) {
            $('#' + modal.id).removeClass('fadeOutUp')
            $('#' + modal.id).addClass('fadeIn')
            $('#' + modal.id).modal('show')

            loadlistParticipatingClients()
        } else {
            $('#' + modal.id).removeClass('fadeIn')
            $('#' + modal.id).addClass('fadeOutUp')
            $('#' + modal.id).modal('hide')
        }
    }, [isVisible, user, productId])

    const loadlistParticipatingClients = () => {
        if (!user || !productId || !hash) return

        setLoadingTable(true)

        TacticalPanelService.listParticipatingClients(
            user.providerId,
            productId,
            hash
        )
            .then((result) => {
                setListClients(result.data)
            })
            .catch((error) => {
                setListClients(null)
                console.error(error)
            })
            .finally(() => {
                setLoadingTable(false)
            })
    }

    return (
        <div
            style={{
                display: 'flex',
                padding: '10px 30px 30px',
                flexDirection: 'column',
                minHeight: '25vh',
                justifyContent: 'space-between',
                margin: '0 auto',
            }}
        >
            {!loadingTable && <h2 className="titleClients">Clientes</h2>}

            <div className="NewListParticipatingClients">
                {loadingTable ? (
                    <Loader type="inline" />
                ) : (
                    <>
                        {listClients && listClients.length > 0 ? (
                            <table>
                                <thead>
                                    <tr>
                                        <th>Cliente</th>
                                        <th>Cidade</th>
                                        <th>UF</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listClients.map((item, index) => (
                                        <tr key={index}>
                                            <td data-label="Cliente">
                                                {item.client_name ?? ''}
                                            </td>
                                            <td data-label="Cidade">
                                                {item.client_city ?? ''}
                                            </td>

                                            <td data-label="UF">
                                                {item.client_state ?? ''}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <FeedbackError
                                message={
                                    'Erro ao buscar lista de clientes, tente novamente mais tarde...'
                                }
                            />
                        )}
                    </>
                )}
            </div>

            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    width: '98%',
                    marginTop: 10,
                }}
            >
                <ButtonV3
                    filled
                    title="Voltar"
                    onClick={() => {
                        onClose()
                    }}
                />
            </div>
        </div>
    )
}
